import dayjs from 'dayjs'
import minMax from 'dayjs/plugin/minMax'

dayjs.extend(minMax)

export const getLatestAvailabilityDate = (products) => {
  if (!products.length) return null

  const datesList = products.map(({ availableAsOf = null, availableToday, availableTomorrow }) => {
    const date = (availableAsOf && dayjs(availableAsOf.split(' ')[0], 'MM-DD-YYYY'))
      || (availableTomorrow && dayjs().add(1, 'day'))
      || (availableToday && dayjs())
      || null

    return date
  })

  const uniqueDatesSet = new Set(datesList)
  const uniqueDatesList = [...uniqueDatesSet]

  if (!uniqueDatesList.length || (uniqueDatesList.length === 1 && !uniqueDatesList[0])) {
    return null
  }

  const filteredDates = uniqueDatesList.filter(date => !!date)
  const latestDate = dayjs.max(filteredDates)

  return latestDate.format('MM/DD/YYYY')
}

